import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "showcase-card__content-wrap" }
const _hoisted_4 = { class: "showcase-card__style" }
const _hoisted_5 = { class: "showcase-card__title balance-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "showcase-card__ctas" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn btn-outline-white" }, "Learn More")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: $options.showcaseUrl,
    class: _normalizeClass(["showcase-card", $options.portfolioClass])
  }, [
    _createElementVNode("img", {
      src: $props.image,
      alt: $props.imageAlt,
      class: "showcase-card__image"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.styleName), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString($props.title), 1 /* TEXT */),
      ($props.credits)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "showcase-card__photographer-designer",
            innerHTML: $options.strippedCredits
          }, null, 8 /* PROPS */, _hoisted_6))
        : _createCommentVNode("v-if", true),
      _hoisted_7
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}